<button [class.position-2]="displayVideoTitle" (click)="onClickButton()"><i class="icon icon-send"></i>
    {{(isTeaserOrTrailer && teaserOrTrailerClicked ? 'media-access-modal.online-access-button-teaser' : 'media-access-modal.online-access-button') | localize}}
</button>
